export function prefetchSantaEditor(santaEditorBaseUrl: string) {
  const prefetchScript = document.createElement('script');
  prefetchScript.src = `${santaEditorBaseUrl}dist/bundle/prefetch.min.js`;
  document.body.appendChild(prefetchScript);
}
